<i-title styleClass="w-100" [text]="'modals.insertQRCode' | translate" [buttons]="titleButtons" level="1"></i-title>

<div class="row modal-body mt-3" [formGroup]="QRForm">
  <div class="col-md-12 mb-3">
    <label class="w-100">
      <span class="super-compos-label-input">{{ 'modals.signatureNumber' | translate }}</span>
      <i-input
        [type]="'text'"
        [iInput]="{ placeholder: 'modals.encodeNumberForSignatureLink' | translate }"
        [control]="QRForm.get('texte')"
        [showError]="false"
        styleClass="d-block w-100"></i-input>
    </label>
  </div>
  <div class="col-md-6 mb-3">
    <label class="w-100">
      <span class="super-compos-label-input">{{ 'modals.width' | translate }}</span>
      <i-input [type]="'number'" [iInput]="{ placeholder: '' }" [control]="QRForm.get('width')" styleClass="d-block w-100"> </i-input>
    </label>
  </div>
  <div class="col-md-6 mb-3">
    <label class="w-100">
      <span class="super-compos-label-input">{{ 'modals.height' | translate }}</span>
      <i-input [type]="'number'" [iInput]="{ placeholder: '' }" [control]="QRForm.get('height')" styleClass="d-block w-100"> </i-input>
    </label>
  </div>
  <div class="col-md-6 mb-3">
    <label class="w-100">
      <span class="super-compos-label-input">{{ 'modals.dpiX' | translate }}</span>
      <i-input [type]="'number'" [iInput]="{ placeholder: '' }" [control]="QRForm.get('dpiX')" styleClass="d-block w-100"> </i-input>
    </label>
  </div>
  <div class="col-md-6 mb-3">
    <label class="w-100">
      <span class="super-compos-label-input">{{ 'modals.dpiY' | translate }}</span>
      <i-input [type]="'number'" [iInput]="{ placeholder: '' }" [control]="QRForm.get('dpiY')" styleClass="d-block w-100"> </i-input>
    </label>
  </div>
</div>
